import React from 'react';
import styled from 'styled-components';
import ds, { media } from 'designsystem';
import Header4 from 'elements/Header4';
import PropTypes from 'prop-types';
import linkIcon from 'common/images/linkIcon.svg';
import Link from 'blocks/StyledLink';

const LinkIcon = styled.span`
  display:inline-block;
  background-image: url(${linkIcon});
  height: 15px;
  width: 15px;
  background-repeat: no-repeat;
  margin-right: ${ds.get('metrics.s')};
`;

const StyledLink = styled(Link)`
  display:flex;
  align-items:center;
  margin: ${ds.get('metrics.base')} 0;

  ${media.desktop`
    margin: 0 ${ds.get('metrics.s')};
  `}
`;

const StyledHeader4 = styled(Header4)`
  margin:0;
  color: ${ds.brand('product')};
`;


const ArticleCategory = ({ slug, description, onClick }) => (
  <StyledLink
    to={slug}
    onClick={onClick}
  >
    <React.Fragment>
      <LinkIcon />
      <StyledHeader4>
        {description}
      </StyledHeader4>
    </React.Fragment>
  </StyledLink>
);
ArticleCategory.propTypes = {
  slug: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};
ArticleCategory.defaultProps = {
  onClick: () => null,
};
export default ArticleCategory;



// WEBPACK FOOTER //
// ./src/pages/BlogArticle/ArticleCategory.jsx